<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            ajax-path="unifi/devices"
            :ajax-params="ajaxParams"
        />
    </div>
</template>

<script>
    import Http from '@/helpers/Http';

    export default {
        props: {
            site: {
                type: String,
                default: null,
            }
        },
        data() {
            return {
                ajaxParams: {},
                columns: [
                    {
                        title: 'Device Name',
                        field: 'name',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Status',
                        field: 'state',
                        sorter: 'string',
                        minWidth: 150,
                        formatter({_cell}) {
                            if (_cell.value) {
                                return `<span class='badge badge-green'>Connected</span>`;
                            }

                            return `<span class='badge badge-red'>Disconnected</span>`;
                        }
                    },
                    {
                        title: 'IP Address',
                        field: 'ip',
                        sorter: 'string',
                        minWidth: 150,
                    },
                    {
                        title: 'MAC Address',
                        field: 'mac',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Model',
                        field: 'model',
                        sorter: 'string',
                        minWidth: 150,
                    },
                    {
                        title: 'Version',
                        field: 'version',
                        sorter: 'string',
                        minWidth: 150,
                    },
                    {
                        title: 'Uptime',
                        minWidth: 150,
                        formatter({_cell}) {
                            if (_cell.row.data.state === 0) {
                                return '--';
                            }

                            let pad = function (num, size) { return ('000' + num).slice(size * -1); };
                            let time = _cell.row.data.uptime;
                            let days = Math.floor(time / 60 / 60 / 24);
                            let hours = Math.floor(time / 60 / 60);
                            let minutes = Math.floor(time / 60) % 60;
                            let seconds = Math.floor(time - minutes * 60);
                            
                            return pad(days, 2) + 'd ' + pad(hours, 2) + 'h ' + pad(minutes, 2) + 'm ' + pad(seconds, 2) + 's';
                        }
                    }
                ],
                actions: [
                    {
                        label: 'Upgrade Software',
                        icon: () => import('@/icons/Update.vue'),
                        handler: items => {
                            this.$swal.fire({
                                type: 'warning',
                                title: 'Are you sure?',
                                html: `You are about to upgrade the software for the device with the mac address of "<strong>${items[0].mac}</strong>".`,
                                showCancelButton: true,
                                confirmButtonColor: '#3182ce',
                                confirmButtonText: 'Yes, upgrade it!',
                                showLoaderOnConfirm: true,
                                preConfirm: (response) => {
                                    return Http.post(`unifi/devices/upgrade`, {mac: items[0].mac, site: this.site});
                                },
                                allowOutsideClick: () => !this.$swal.isLoading()
                            })
                            .then((result) => {
                                if (result.value) {
                                    this.refreshTable = true;
                                    this.$swal.fire({
                                        type: 'success',
                                        title: 'Success!',
                                        text: 'Device software was successfully upgraded.'
                                    })
                                }
                            })
                        }
                    }
                ],
            }
        },
        mounted() {
            this.ajaxParams = {
                site: this.site,
            }
        }
    }
</script>